import { render, staticRenderFns } from "./programSession.vue?vue&type=template&id=895d0fa4"
import script from "./programSession.vue?vue&type=script&lang=js"
export * from "./programSession.vue?vue&type=script&lang=js"
import style0 from "./programSession.vue?vue&type=style&index=0&id=895d0fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports